// Widget API service
import api from './api';

const widgetService = {
  // Get widget settings for current workspace
  async getSettings() {
    return await api.request('/widget/settings');
  },

  // Update widget settings
  async updateSettings(settings) {
    return await api.request('/widget/settings', {
      method: 'PUT',
      body: settings
    });
  },

  // Regenerate API key
  async regenerateApiKey() {
    return await api.request('/widget/regenerate-key', {
      method: 'POST'
    });
  },

  // Get widget analytics
  async getAnalytics(days = 30) {
    return await api.request(`/widget/analytics?days=${days}`);
  }
};

export default widgetService;
